import React, { Suspense, useRef, useState } from "react";
import { AdditionalFieldsData } from "./data/AdditionalFields.data";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";
import Accordion from "../../../components/Accordion/Accordion";
import FormCreator from "../../../components/Forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { AddSGBSCategoryData } from "./data/AddSGBSCategory.data";

const initialData = [
  {
    id: 1,
    label: "TVOC",
    inputType: "Text Box",
    mandatory: "Yes",
  },
  {
    id: 2,
    label: "HVOC",
    inputType: "Tick Rating",
    mandatory: "Yes",
  },
  {
    id: 3,
    label: "GWP",
    inputType: "Text Box",
    mandatory: "No",
  },
];

const AddSGBSCategory = () => {
  const addSGBPCategoryRefs = useRef();
  const [formData] = useState(AddSGBSCategoryData);
  const [AdditionalFields] = useState(AdditionalFieldsData);
  const [rows, setRows] = useState(initialData);
  const [showAcceptModal, setShowAcceptModal] = useState(false);

  const handleAcceptApplication = () => {
    setShowAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
  };

  const handleDelete = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleEdit = (id) => {
    alert("Edit clicked for id: " + id);
  };
  return (
    <div className="add-requirement">
      <Suspense fallback={<DataLoader />}>
        <Accordion
          title="Add New Criteria Mapping"
          className="mb-4"
          button={false}
          accordion={false}
        >
          <div className="row">
            <FormCreator ref={addSGBPCategoryRefs} {...formData} />
          </div>
        </Accordion>
        <div className="add-requirement-btn-wrapper">
          <Buttons
            buttonText="Back"
            buttonTypeClassName="btn btn-secondary mb-2"
            // onClick={handleClearClick}
          />
          <div className="save-btn-wrapper">
            <Buttons
              buttonText="Save"
              buttonTypeClassName="add-btn"
              // onClick={handleAddRow}
            />
          </div>
        </div>

      </Suspense>
    </div>
  );
};

export default AddSGBSCategory;
